// components/Tables/ConfigMatriculasTable_v2.jsx
import React from 'react'
import ArticulosTableLoader from 'components/Loaders/ArticulosTableLoader'
import { useGetAllMatriculasByProject } from 'lib/react-query/queriesModuloType'
import ConfigMatriculasRow from './ConfigMatriculasRow'
import { useConfigMatriculas } from 'context/ConfigMatriculasContext'
import { ReusableTable } from 'components/Tables/ReusableTable'

export const ConfigMatriculasTable_v2 = () => {
  const { data, isLoading, isFetching } = useGetAllMatriculasByProject()
  const { textFieldValue } = useConfigMatriculas()

  if (isLoading || !data) return <ArticulosTableLoader />

  // Filtramos y ordenamos por código
  const filtered = data.data
    .filter(item =>
      item.code.toLowerCase().includes(textFieldValue.toLowerCase())
    )
    .sort((a, b) => a.code.localeCompare(b.code))

  return (
    <div
      className="fabrica-matriculas-table-container"
      style={{ flex: 1, overflowY: 'auto', marginTop: '1rem' }}
    >
      <ReusableTable
        className="min-w-full"
        dataHeader={['Matrícula', 'Visibilidad']}
        headerClassNames={['ta-left', 'ta-right visibility-header']}
      >
        {filtered.length > 0 ? (
          filtered.map(item => (
            <ConfigMatriculasRow
              matricula={item}
              key={item._id}
              isFetching={isFetching}
            />
          ))
        ) : (
          <tr>
            <td
              colSpan={2}
              style={{ fontStyle: 'oblique', margin: '1rem 0 1rem .5rem' }}
            >
              No hay matrículas para mostrar
            </td>
          </tr>
        )}
      </ReusableTable>
    </div>
  )
}

export default ConfigMatriculasTable_v2
